// Only remove legacy, standalone lighting metadata lines. A character may say
// "打光提示词：..." inside a shot; that story text must remain untouched.
const LEGACY_LIGHTING_LINE = /^[\t ]*(?:打光提示词|补充打光要求)[\t ]*[：:][^\n]*(?:\n|$)/gm;
const LEGACY_LIGHTING_VALUE = /^[\t ]*(?:打光提示词|补充打光要求)[\t ]*[：:][\t ]*([^\n]*)$/m;

export const stripStandaloneLightingBlocks = (prompt) => String(prompt ?? "")
  .replace(/\r\n?/g, "\n")
  .replace(LEGACY_LIGHTING_LINE, "")
  .replace(/\n{3,}/g, "\n\n")
  .trim();

export const extractLegacyLightingPrompt = (prompt) => (
  String(prompt ?? "").replace(/\r\n?/g, "\n").match(LEGACY_LIGHTING_VALUE)?.[1]?.trim() || ""
);

// Lighting is saved separately from the storyboard text. Only the outbound copy
// needs this suffix; callers must not persist the returned string as seedancePrompt.
export const appendDetachedLightingPrompt = (prompt, lightingPrompt) => {
  const source = String(prompt ?? "");
  const lighting = String(lightingPrompt ?? "").trim();
  if (!lighting) return source;
  const suffix = `\n\n打光提示词：${lighting}`;
  return source.endsWith(suffix) ? source : `${source}${suffix}`;
};
